import { MessagesGetResultApi } from '../api-typings/messages/messages_types';
import { Backend } from '../backend';
import { getQueryParamValue } from '../store.helpers';

declare module '../backend' {
  interface BackendApiFetchTypes {
    messages: MessagesGetResultApi;
  }
}

export const messagesBackend: Backend<'messages'> = {
  fetch: (_, key2, query) => ({
    endpoint: `messages/0.1/messages`,
    params: {
      threads: query ? getQueryParamValue(query, 'threadId') : [],
      thread_details: 'true',
      user_details: 'true',
    },
  }),
  post: (_, entity) => ({
    endpoint: `messages/0.1/threads/${entity.threadId}/messages/`,
    params: { thread_id: entity.threadId },
  }),
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/messages/messages.backend.ts